var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from './BaseModel';
import { values, isArray } from 'lodash';
var DeliveryFlowModel = /** @class */ (function (_super) {
    __extends(DeliveryFlowModel, _super);
    function DeliveryFlowModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.baseDeliveryFee = hydrated.baseDeliveryFee;
        _this.deliveryRadius = hydrated.deliveryRadius;
        _this.deliveryRadiusUnit = hydrated.deliveryRadiusUnit;
        _this.deliveryRegions = hydrated.deliveryRegions;
        _this.googleMapsApiKey = hydrated.googleMapsApiKey;
        _this.hasDeliveryRegionsSet = hydrated.hasDeliveryRegionsSet;
        _this.mileageReimbursement = hydrated.mileageReimbursement;
        _this.minimumDelivery = hydrated.minimumDelivery;
        _this.promiseTime = hydrated.promiseTime;
        _this.taxableDelivery = hydrated.taxableDelivery;
        _this.__mc = 'DeliveryFlowModel';
        return _this;
    }
    DeliveryFlowModel.prototype.hydrate = function (data) {
        var hydrated = {};
        hydrated.baseDeliveryFee = parseInt(data.base_delivery_fee) || 0;
        hydrated.deliveryRadius = +(data.delivery_radius) || 5;
        hydrated.deliveryRadiusUnit = data.delivery_radius_unit || 'miles';
        hydrated.deliveryRegions = DeliveryFlowModel.convertDeliveryRegionsObject(data.delivery_regions);
        hydrated.googleMapsApiKey = data.google_maps_api_key || null;
        hydrated.hasDeliveryRegionsSet = DeliveryFlowModel.verifyDeliveryRegionsSetup(hydrated.deliveryRegions);
        hydrated.mileageReimbursement = +(data.mileage_reimbursement) || 0;
        hydrated.minimumDelivery = +(data.delivery_min_subtotal) || 0;
        hydrated.promiseTime = +(data.promise_time) || 0;
        hydrated.taxableDelivery = data.taxable_delivery;
        return hydrated;
    };
    DeliveryFlowModel.prototype.hydrateFromStore = function (data) {
        return data;
    };
    DeliveryFlowModel.convertDeliveryRegionsObject = function (deliveryRegions) {
        if (!deliveryRegions) {
            return null;
        }
        if (typeof deliveryRegions === 'object' && !isArray(deliveryRegions)) {
            deliveryRegions = values(deliveryRegions);
        }
        if (!isArray(deliveryRegions)) {
            return null;
        }
        return deliveryRegions.map(function (region) {
            return {
                kmlFile: region.kml_file,
                deliveryFee: parseInt(region.delivery_fee) || null,
                processedPoints: region.processed_points && region.processed_points.length
                    ? region.processed_points.map(function (point) {
                        return { lat: parseFloat(point.lat), lng: parseFloat(point.lon) };
                    })
                    : null
            };
        });
    };
    DeliveryFlowModel.verifyDeliveryRegionsSetup = function (deliveryRegions) {
        // check if delivery regions are correctly defined
        if (!deliveryRegions || !isArray(deliveryRegions)) {
            return false;
        }
        var isDeliverySetup = false;
        deliveryRegions.forEach(function (region) {
            if (region.kmlFile && region.deliveryFee && region.processedPoints) {
                isDeliverySetup = true;
            }
        });
        return isDeliverySetup;
    };
    return DeliveryFlowModel;
}(BaseModel));
export default DeliveryFlowModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/DeliveryFlowModel.ts
// module id = pQfs
// module chunks = 18